<template>
    <div>
        <div class="main-recycle-box">
            <p class="title">구민의 미래를 위한 <strong>자원순환센터</strong></p>
            <p class="text">은평구민과 함께하는<br>모범적인 환경시설로 만들어 나가겠습니다.</p>
            <a href="#" @click.prevent="openPop('summary')">자원순환센터 개요</a>
            <a href="#" @click.prevent="openPop('info')">바로알기</a>

            <div class="recycle-player-tab main">
                <a href="#" class="recycle-btn active" @click.prevent="showVideo('A')">은평광역자원순환센터는 꼭 필요합니다</a>
                <a href="#" class="recycle-btn active" @click.prevent="showVideo('B')">은평광역자원순환센터 바로알기</a>
            </div>
        </div>

        <transition name="modal">
            <RecycleInfoWin v-show="isShowInfo" @close-info-win="showInfoWin(false)" />
        </transition>

        <transition name="modal">
            <RecycleSummaryWin v-show="isShowSummary" @close-summary-win="showSummaryWin(false)" />
        </transition>

        <transition name="modal">
            <RecycleVideoWin v-if="isShowVideo" :video-type="videoType" @close-video-win="showVideoWin(false)" />
        </transition>
    </div>
</template>

<script>
import RecycleInfoWin from '@/views/biz/RecycleInfoWin.vue';
import RecycleSummaryWin from '@/views/biz/RecycleSummaryWin.vue';
import RecycleVideoWin from '@/views/biz/RecycleVideoWin.vue';
export default {
    name: 'RecycleCard',
    data() {
        return {
            isShowSummary: false,
            isShowInfo: false,
            isShowVideo: false,
            videoType: 'A',
        };
    },
    created() {
        this.$eventBus.$on('moved-card', this.thisCardOn);
    },
    methods: {
        showSummaryWin(isShow) {
            this.isShowSummary = isShow;
        },
        showInfoWin(isShow) {
            this.isShowInfo = isShow;
        },
        openPop(popName) {
            if (popName === 'summary') {
                this.isShowSummary = true;
            } else {
                this.isShowInfo = true;
            }
        },
        showVideoWin(isShow) {
            this.isShowVideo = isShow;
        },
        showVideo(videoType) {
            if (videoType === 'A') {
                this.videoType = 'A';
            } else {
                this.videoType = 'B';
            }
            this.showVideoWin(true);
        },
    },
    components: {
        RecycleInfoWin,
        RecycleSummaryWin,
        RecycleVideoWin
    }
}
</script>

<style scoped>

</style>
